import React from 'react';
import verificado from '../../imagenes/verificado.png'
import './Auth.css';

const VerificationSuccess = ({ setAuthStep, setIsLoggedIn }) => {
  const handleSignIn = () => {
    setIsLoggedIn(true);
    setAuthStep(null);
  };

  return (
    <div className="auth-container">
      <div className="success-content">
        <div className="success-icon">🎉</div>
        <h2>Exelente!!!</h2>
        <p>Su número de móvil ha sido verificado exitosamente</p>
          <img className='hombre2'
          src={verificado}alt='celular con visto'  
          />
        <button className="auth-btn primary" onClick={handleSignIn}>
          Sign In
        </button>
      </div>
    </div>
  );
};

export default VerificationSuccess;